import * as React from "react"

const MOBILE_BREAKPOINT = 768

function getIsMobile() {
  if (typeof window === "undefined") return false
  return window.innerWidth < MOBILE_BREAKPOINT
}

export function useIsMobile() {
  // Compute the correct value synchronously on the first render. The previous
  // `undefined` initial value rendered one frame as "not mobile", which let the
  // sidebar mount in its desktop (hidden) form on a phone — so the bottom-nav
  // menu button silently did nothing until a later resize/rotation corrected
  // the value. A lazy initializer removes that stale first paint.
  const [isMobile, setIsMobile] = React.useState<boolean>(getIsMobile)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => setIsMobile(getIsMobile())
    // Listen on every path the viewport width can change: a breakpoint
    // crossing (matchMedia), device rotation, and ordinary resizes (e.g. the
    // iOS Safari toolbar growing/shrinking). Some mobile browsers report a
    // stale width on the initial load and only settle after an orientation
    // event, so covering all three keeps the value honest.
    mql.addEventListener("change", onChange)
    window.addEventListener("resize", onChange)
    window.addEventListener("orientationchange", onChange)
    onChange()
    return () => {
      mql.removeEventListener("change", onChange)
      window.removeEventListener("resize", onChange)
      window.removeEventListener("orientationchange", onChange)
    }
  }, [])

  return isMobile
}
